import type { ScopeLevel } from "../types/index.js";

/**
 * Scope adjustment applied to a project's base/anchor renovation line
 * item (see docs/calculation-engine.md). This is distinct from the
 * finish-level multiplier already carried on each pricing line item:
 * scope answers "how much of the space is being redone" (a cosmetic
 * refresh touches far less than a full gut renovation), while finish
 * level answers "how nice are the materials/labour for the work that IS
 * being done." Both apply, to different things, without double-counting.
 */
export const SCOPE_MULTIPLIERS: Record<ScopeLevel, number> = {
  cosmetic_refresh: 0.55,
  mid_range_remodel: 1.0,
  full_gut_renovation: 1.35,
  custom_high_end: 1.65
};

export function getScopeMultiplier(scope: ScopeLevel): number {
  return SCOPE_MULTIPLIERS[scope] ?? 1.0;
}
